import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class CustomErrorHandlerService implements ErrorHandler {
  handleError(error: any): void {
    console.log('error: ', error);
    console.error('error: ', error);

    // Check for the specific dynamic import error
    if (
      error instanceof TypeError &&
      (error.message.includes('Failed to fetch dynamically imported module') || error.message.includes('Importing a module script failed'))
    ) {
      console.log('Dynamic import error detected, refreshing page...');
      window.location.reload();
    }
  }
}
